import { TFunction } from "i18next";
import { DatePickerValidationError } from "../../enums/DatePickerValidationError";
import { DaysOfWeekValidationError } from "../enums/DaysOfWeekValidationError";

export interface RecurringScheduleEmailValidationError {
  startDate: DatePickerValidationError | undefined;
  endDate: DatePickerValidationError | undefined;
  daysOfWeek: DaysOfWeekValidationError | undefined;
}

export const getDateValidationErrorMessage = (
  t: TFunction,
  validationError: DatePickerValidationError,
): string => {
  switch (validationError) {
    case DatePickerValidationError.EmptyDate:
      return t("emailCycles.emptyDateErrorMessage");
    case DatePickerValidationError.InvalidDate:
      return t("emailCycles.invalidDateErrorMessages");
    default:
      return validationError satisfies never;
  }
};

export const getDaysOfWeekValidationErrorMessage = (
  t: TFunction,
  validationError: DaysOfWeekValidationError,
): string => {
  switch (validationError) {
    case DaysOfWeekValidationError.EmptyValue:
      return t("emailCycles.emptyDaysOfWeekErrorMessage");
    default:
      return validationError satisfies never;
  }
};

export const getRecurringScheduleEmailValidationErrorMessage = (
  t: TFunction,
  validationErrors: RecurringScheduleEmailValidationError,
): Record<keyof RecurringScheduleEmailValidationError, string | undefined> => ({
  startDate: validationErrors.startDate
    ? getDateValidationErrorMessage(t, validationErrors.startDate)
    : undefined,
  endDate: validationErrors.endDate
    ? getDateValidationErrorMessage(t, validationErrors.endDate)
    : undefined,
  daysOfWeek: validationErrors.daysOfWeek
    ? getDaysOfWeekValidationErrorMessage(t, validationErrors.daysOfWeek)
    : undefined,
});
